export default "__VITE_ASSET__B$qlr5n9__";